import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "row mt-1 text-center" }
const _hoisted_4 = { class: "col-12 col-md-6 mb-0 d-flex align-items-stretch mb-5 mb-md-0" }
const _hoisted_5 = { class: "info-box pt-1 px-1 rounded" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center justify-content-center pt-3 bg-white rounded-top" }
const _hoisted_7 = { class: "d-flex align-items-center w-100 px-3 mt-0 pb-3 mb-3 bg-white rounded-bottom" }
const _hoisted_8 = ["max", "step"]
const _hoisted_9 = { class: "m-1" }
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = { class: "col-12 col-md-6 mb-0 d-flex align-items-stretch" }
const _hoisted_12 = { class: "info-box pt-1 px-1 rounded" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-center pt-3 bg-white rounded-top" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = {
  class: "d-inline-block text-end font-monospace text-nowrap fs-5",
  style: {"min-width":"5ch"}
}
const _hoisted_16 = { class: "d-flex align-items-center w-100 px-3 mt-0 pb-3 mb-3 bg-white rounded-bottom" }
const _hoisted_17 = { class: "m-1" }

import { ref, computed, Ref } from "vue";
    import Help from "@/guiide/components/common/Help.vue";
    import TaxFreeLumpSumDescriber from "@/guiide/components/dboptions/TaxFreeLumpSumDescriber.vue";
    import OptionsQuestion from "@/guiide/components/common/OptionsQuestion.vue";
    import { formatter } from "@/shared/ts/formatter";
    import TaxFreeCashModelSupporter from "@/guiide/ts/assets/finalsalary/taxFreeCashModelSupporter";
    import DBOptionsChart from "@/guiide/components/charts/DBOptionsChart.vue";
    import { ChartData, X, Y } from "@/guiide/ts/charts/chartDataPoint";
    import { FinalSalaryOptionInfoStatic } from "@/guiide/ts/assets/finalsalary/finalSalaryOptionInfoStatic";
    import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
    import FinalSalarySchemeOptionsDetailResponse from "@/guiide/ts/response/finalSalarySchemeOptionsDetailResponse";
    import DBOptionsStats from "@/guiide/components/dboptions/DBOptionsStats.vue";
    import FinalSalarySchemeOptionsDetail from "@/guiide/ts/response/finalSalarySchemeOptionsDetail";
    import { getAgeAtEndOfPlanningPeriod } from "@/guiide/ts/utilities";
    import { useFinalSalaryStaticOptions } from "@/guiide/ts/assets/finalsalary/useFinalSalaryOptionInfoStatic";
    import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

    const chartDataPointFirstYearIndex = 0;
    const chartDataPointAmountIndex = 1;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Modelling',
  props: /*@__PURE__*/_mergeModels({
        selectedOptionName: { type: String, required: true},
        availableOptionsStatic: { type: Object as () => FinalSalaryOptionInfoStatic[], required: true },
        taxFreeCashModelSupporter: { type: TaxFreeCashModelSupporter, required: true },
        fsOptionsDynamic: { type: Object as () => FinalSalarySchemeOptionsDetailResponse, required: true },
        avcPotAmount: { type: Number, required: true }
    }, {
    "selectedOptionStartingPension": { default: () => 0 },
    "selectedOptionStartingPensionModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels([ "update:selectedOptionName" ], ["update:selectedOptionStartingPension"]),
  setup(__props, { emit: __emit }) {

    const props = __props;

    const selectedOptionStartingPension = _useModel<number>(__props, 'selectedOptionStartingPension');

    const emit = __emit;

    const { htmlArray, templateTextArray } = useUIContent();

    const ageChartDataIndex = X, amountChartDataIndex = Y;
    const averageSchemeIncreases = ref(2.5);
    const averagePIEIncreases = ref(2.5);
    const crossoverAge = ref("");
    const breakevenAge = ref("");
    const futureInflationModel = ref(2.5);

    const { finalSalaryOptionsStatic } = useFinalSalaryStaticOptions();
    const standardOption = ref<FinalSalarySchemeOptionsDetail>(props.fsOptionsDynamic.options.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault));
    const pieOption = ref<FinalSalarySchemeOptionsDetail>(props.fsOptionsDynamic.options.find(fsoi => fsoi.type == FinalSalaryOption.PensionIncreaseExchange));
    const bpoOption = ref<FinalSalarySchemeOptionsDetail>(props.fsOptionsDynamic.options.find(fsoi => fsoi.type == FinalSalaryOption.BridgingPension));

    const showPIEStats = computed<boolean>(() => {
        const pieOptionDetail = props.fsOptionsDynamic.options.find(o => o.type == FinalSalaryOption.PensionIncreaseExchange);
        if (pieOptionDetail?.show ?? false) {
            return true;
        }

        const pieBPOptionDetail = props.fsOptionsDynamic.options.find(o => o.type == FinalSalaryOption.PIEBP);
        if (pieBPOptionDetail?.show ?? false) {
            return true;
        }

        return false;
    });

    const userHasMultipleOptions = computed<boolean>(() => props.availableOptionsStatic.length > 1);

    const localSelectedOptionName = computed({
        get: () => props.selectedOptionName,
        set: (value) => emit('update:selectedOptionName', value)
    });

    const selectedOption = computed<FinalSalaryOption>(() => finalSalaryOptionsStatic.value.optionFromString(localSelectedOptionName.value));

    const showPIEDetails = computed<boolean>(() => selectedOption.value == FinalSalaryOption.PensionIncreaseExchange);
    const showBridgingPensionDetails = computed<boolean>(() => selectedOption.value == FinalSalaryOption.BridgingPension);

    const crossoverAgeRelevant = computed<boolean>(() => finalSalaryOptionsStatic.value.get(selectedOption.value)?.crossoverAgeRelevant);

    const incomeGraphData = computed(() => {
        const chartData: ChartData = [];

        if (!props.fsOptionsDynamic) {
            const emptySeries = createGraphSeries(chartData, "", "");
            return [ emptySeries ];
        }

        const schemeGraphData = getDataForGraph(FinalSalaryOption.SchemeDefault, standardOption.value?.maxTaxFreeCash ?? 0, averageSchemeIncreases, 'Standard pension payments', '#99acb0');
        let selectedOptionGraphData = schemeGraphData;

        let optionGraphData: any = null;
        if (showPIEDetails?.value) {
            optionGraphData = getDataForGraph(FinalSalaryOption.PensionIncreaseExchange, pieOption.value?.maxTaxFreeCash ?? 0, averagePIEIncreases, 'PIE option payments', '#00bfff');
            selectedOptionGraphData = optionGraphData;
        } else if (showBridgingPensionDetails?.value) {
            optionGraphData = getDataForGraph(FinalSalaryOption.BridgingPension, bpoOption.value?.maxTaxFreeCash ?? 0, undefined, 'BP option payments', '#cf9465');
            selectedOptionGraphData = optionGraphData;
        }

        selectedOptionStartingPension.value = selectedOptionGraphData.data[chartDataPointFirstYearIndex][chartDataPointAmountIndex];

        const crossover = optionGraphData
            ? getCrossoverAge(schemeGraphData.data, optionGraphData.data)
            : null;
        crossoverAge.value = crossover == null || !crossoverAgeRelevant.value ? "n/a" : Math.floor(crossover).toString();

        const comparativeOptionSelected = selectedOption.value != FinalSalaryOption.SchemeDefault;
        if (comparativeOptionSelected) {
            const breakeven = optionGraphData
                ? identifyBreakeven(crossover, schemeGraphData.data, optionGraphData.data)
                : null;
            breakevenAge.value = breakeven == null ? (getAgeAtEndOfPlanningPeriod() ?? 0).toString() + "+" : breakeven.toString();
        } else {
            breakevenAge.value = "n/a";
        }

        const data = [schemeGraphData];
        if (optionGraphData) {
            data.push(optionGraphData);
        }

        return data;
    });

    const taxFreeCashModel = computed({
        get: () => props.taxFreeCashModelSupporter.selected,
        set: (newValue: number) => {
            props.taxFreeCashModelSupporter.selected = newValue;
            props.taxFreeCashModelSupporter.refresh();
        }
    });

    const tfcText = computed<string[]>(() => {
        const avcPotAmountFormatted = formatter.formatCurrency(props.avcPotAmount);
        const variantKey = props.avcPotAmount == 0 ? "without-avc-pot" : "with-avc-pot";
        return templateTextArray("dboptions.modelling.tfc.body.text", variantKey, { avcPotAmount: avcPotAmountFormatted });
    });

    const availablePensionOptionNames = computed<string[]>(() => props.availableOptionsStatic.map(item => item.name));

    function getDataForGraph(option: FinalSalaryOption, maxTaxFreeCash: number, schemeIncreases: Ref<number> | undefined, seriesName: string, seriesColour: string) {
        const charts = props.fsOptionsDynamic.options[option].charts;
        const taxFreeCashTotal = Math.min(maxTaxFreeCash, props.taxFreeCashModelSupporter?.selected ?? 0);
        const taxFreeCashFromPension = Math.max(0, taxFreeCashTotal);
        const taxFreeCashInterval = props.fsOptionsDynamic.taxFreeCashSliderInterval;
        const dataRange = props.fsOptionsDynamic.yearsToProject + 1;

        const dataForChart = getChartData(charts, taxFreeCashFromPension, futureInflationModel.value, taxFreeCashInterval, dataRange);

        if(schemeIncreases) {
            schemeIncreases.value = dataForChart[0] / 100;
        }

        const chartData = dataForChart.slice(1);
        const chart = insertRetirementYears(chartData, props.fsOptionsDynamic.startingAge);
        return createGraphSeries(chart, seriesName, seriesColour);
    }

    function getChartData(data: number[], taxFreeCash: number, futureInflation: number, taxFreeCashInterval: number, dataRange: number): number[] {
        const taxFreeCashSteps = props.taxFreeCashModelSupporter.ticks;
        const taxFreeCashIndex = Math.ceil(taxFreeCash / taxFreeCashInterval);
        const inflationIndex = Math.round(futureInflation / 0.1);
        const chartIndex = inflationIndex * taxFreeCashSteps + taxFreeCashIndex;
        const startIndex = chartIndex * dataRange;
        return data.slice(startIndex, startIndex + dataRange);
    }

    function insertRetirementYears(chartData: number[], startYear: number = 0): number[][] {
        return chartData.map((amount, year) => [year + startYear, amount]);
    }

    function createGraphSeries(data: ChartData, name: string, color: string) {
        return {
            "name": name,
            "data": data,
            "visible": true,
            "color": color,
            "type": "line",
            "marker": {
                "enabled": false
            }
        }
    }

    function identifyBreakeven(crossoverAge: number | null, schemeIncome: ChartData, optionIncome: ChartData): number | null {
        const breakevenIsRelevant = showPIEDetails.value || showBridgingPensionDetails.value;

        if (crossoverAge == null || !breakevenIsRelevant) {
            return null;
        }

        let schemeTotal = 0;
        let optionTotal = 0;
        let runningDiff = 0;

        for (let retirementYear = 0; retirementYear < schemeIncome.length; retirementYear++) {
            const schemeIncomePoint = schemeIncome[retirementYear];
            const optionIncomePoint = optionIncome[retirementYear];

            schemeTotal += schemeIncomePoint[amountChartDataIndex];
            optionTotal += optionIncomePoint[amountChartDataIndex];
            runningDiff = optionTotal - schemeTotal;

            if (runningDiff < 0) {
                return schemeIncomePoint[ageChartDataIndex];
            }
        }

        return null;
    }

    function getCrossoverAge(schemeIncome: ChartData, optionIncome: ChartData): number | null {
        for (let i = 1; i < schemeIncome.length; i++) {
            const [agePrev, schemePrev] = schemeIncome[i - 1];
            const [, optionPrev] = optionIncome[i - 1];
            const [ageCurr, schemeCurr] = schemeIncome[i];
            const [, optionCurr] = optionIncome[i];

            const diffPrev = schemePrev - optionPrev;
            const diffCurr = schemeCurr - optionCurr;

            if (diffPrev === 0) {
                return agePrev;
            }

            if (diffPrev * diffCurr < 0) {
                const proportion = diffPrev / (diffPrev - diffCurr);
                const crossoverAge = agePrev + proportion * (ageCurr - agePrev);
                return crossoverAge;
            }
        }

        return null;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(OptionsQuestion, {
        name: "schemeOption",
        question: "",
        options: availablePensionOptionNames.value,
        selected: localSelectedOptionName.value,
        "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((localSelectedOptionName).value = $event))
      }, null, 8, ["options", "selected"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DBOptionsChart, { "graph-data": incomeGraphData.value }, null, 8, ["graph-data"])
    ]),
    _createVNode(DBOptionsStats, {
      "life-expectancy": (_unref(getAgeAtEndOfPlanningPeriod)() ?? 0).toString(),
      breakevenAge: breakevenAge.value,
      crossoverAge: crossoverAge.value,
      averageSchemeIncreases: averageSchemeIncreases.value,
      showPIEStats: showPIEStats.value,
      averagePIEIncreases: averagePIEIncreases.value,
      selectedOption: selectedOption.value,
      "user-has-multiple-options": userHasMultipleOptions.value
    }, null, 8, ["life-expectancy", "breakevenAge", "crossoverAge", "averageSchemeIncreases", "showPIEStats", "averagePIEIncreases", "selectedOption", "user-has-multiple-options"]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row mt-3" }, [
      _createElementVNode("p", null, "You can use the below sliders to explore how they impact the chart and statistics above.")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TaxFreeLumpSumDescriber, {
              model: __props.taxFreeCashModelSupporter,
              "selected-option": selectedOption.value
            }, null, 8, ["model", "selected-option"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "me-md-2 mb-2 mb-md-0" }, "0", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "range",
              class: "form-range w-100 mx-md-2 mb-2 mb-md-0",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((taxFreeCashModel).value = $event)),
              min: "0",
              max: __props.taxFreeCashModelSupporter.sliderMax,
              step: __props.taxFreeCashModelSupporter.step
            }, null, 8, _hoisted_8), [
              [
                _vModelText,
                taxFreeCashModel.value,
                void 0,
                { number: true }
              ]
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ms-md-2 mb-2 mb-md-0" }, "Max", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(Help, {
                title: "Tax free cash maximum",
                text: __props.taxFreeCashModelSupporter.getOptionsDescription(_unref(finalSalaryOptionsStatic))
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "fw-bold" }, "Tax free cash wanted", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tfcText.value, (tfcTextElement, i) => {
              return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(tfcTextElement), 1))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, [
              _createElementVNode("p", _hoisted_14, [
                _cache[6] || (_cache[6] = _createTextVNode(" Future inflation: ")),
                _createElementVNode("span", _hoisted_15, _toDisplayString(futureInflationModel.value) + "%", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "me-md-2 mb-2 mb-md-0" }, "0", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "range",
              class: "form-range w-100 mx-md-2 mb-2 mb-md-0",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((futureInflationModel).value = $event)),
              min: "0",
              max: "5",
              step: "0.1"
            }, null, 512), [
              [_vModelText, futureInflationModel.value]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ms-md-2 mb-2 mb-md-0" }, "5%", -1)),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(Help, {
                title: "Future inflation",
                text: _unref(htmlArray)('dboptions.important-info.inflation.read-more.body')
              }, null, 8, ["text"])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "p-2" }, [
            _createElementVNode("h4", { class: "fw-bold" }, "Future expected inflation"),
            _createElementVNode("p", null, "Use the slider to explore how different levels of inflation could impact your retirement income.")
          ], -1))
        ])
      ])
    ])
  ], 64))
}
}

})